import { render, staticRenderFns } from "./deleteFloor.vue?vue&type=template&id=ad268b1a"
import script from "./deleteFloor.vue?vue&type=script&lang=js"
export * from "./deleteFloor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports